import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { EXPORT_TYPES } from '@Services/ExportService/ExportConstants';
import { chemQuoteExportTabReducerKey } from './ExportTabConstants';
import { chemquoteExportReducer as reducer } from './ExportTabReducer';
import { chemquoteExportTabSelectors as selectors } from './ExportTabSelectors';
import { chemquoteExportActions as actions } from './ExportTabActions';
import ExportTab from './ExportTab';

const {
  exportResult: exportResultSelector,
  exportType: exportTypeSelector,
  retryDisabled: retryDisabledSelector,
  tooltipModalOpened: tooltipModalOpenedSelector,
} = selectors;

const { initializeTab, closeTab, retry, downloadByURL, cancel, setTooltipModalOpened } = actions;

const mapStateToProps = (state) => ({
  exportResult: exportResultSelector(state),
  exportType: exportTypeSelector(state),
  retryDisabled: retryDisabledSelector(state),
  tooltipModalOpened: tooltipModalOpenedSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  initializeTab: () => dispatch(initializeTab({ exportType: EXPORT_TYPES.CHEMQUOTE, canRestore: false })),
  closeTab: () => dispatch(closeTab()),
  cancel: (becauseOfError, skipCancelRequest) => dispatch(cancel(becauseOfError, skipCancelRequest)),
  retry: () => dispatch(retry()),
  downloadByURL: () => dispatch(downloadByURL()),
  toggleTooltipModal: (isOpen) => dispatch(setTooltipModalOpened(isOpen)),
});

export default compose(withReducer(chemQuoteExportTabReducerKey, reducer), connect(mapStateToProps, mapDispatchToProps))(ExportTab);
